import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@codeandweb/ngx-translate';
import { Environment } from '@environment/environment';
import { EnvironmentNames } from '@environment/environment.enum';
import { ErrorBase } from '@models/classes/error-base.model';
import { GenericError } from '@models/classes/generic.error';
import { HttpError } from '@models/classes/http-error.model';
import { AppVersionResponse } from '@models/dto/app-version-response.dto';
import { ErrorCode } from '@models/enums/error.codes';
import { AjaxResponse } from '@models/types/ajax-response.type';
import { DialogService } from '@progress/kendo-angular-dialog';
import { HttpService } from '@services/http/http.service';
import { compare, genSalt, hash } from 'bcryptjs';
@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  dialogSvc: DialogService = inject(DialogService);
  private translateSvc: TranslateService = inject(TranslateService);
  readonly httpSvc: HttpService = inject(HttpService);

  formatDate(dateString: string, withTime?: boolean) {
    if(dateString) {
      dateString = dateString.split('T')[0];
    }

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');  // Ensure two digits
    const month = date.toLocaleString('default', { month: 'short' });  // Get month abbreviation
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();

    if (withTime == true) {
      return `${day}-${month.toUpperCase()}-${year} ${hours}:${minutes} `;
    } else {
      return `${day}-${month.toUpperCase()}-${year}`;
    }

  }

  showErrorPopup(title: string = 'Error', msg: string = 'Error in fetching data') {
    this.dialogSvc.open({
      title: title,
      content: msg
    });
  }


  getErrorMessage(errorObj: any): string {
    let errorMsg = this.translateSvc.instant('errorMsg') ?? 'Some error occurred';

    if (Environment.environment === EnvironmentNames.local) {
      if (typeof errorObj === 'string') {
        errorMsg = errorMsg;
      } else if (errorObj instanceof ErrorBase) {
        errorMsg = errorObj.message;
      }
    } else {
      if (errorObj instanceof HttpError) {
        if (errorObj.errorCode === ErrorCode.NETWORK_ERROR || errorObj.errorCode === ErrorCode.NO_INTERNET) {
          errorMsg = errorObj.message;
        }
      } else if (errorObj instanceof GenericError) {
        if (
          errorObj.errorCode === ErrorCode.GEO_CODE_API_ERROR ||
          errorObj.errorCode === ErrorCode.ATT_UP_SYNC_FAILED ||
          errorObj.errorCode === ErrorCode.ATT_DOWN_SYNC_FAILED ||
          errorObj.errorCode === ErrorCode.SYNC_FAILED
        ) {
          errorMsg = errorObj.message;
        }
      }
    }

    return errorMsg;
  }

  /**
   * Insert impurity in a string
   * @param key string to be impure
   * @returns `string` returns an impure string
   */
  setImpurity(key: string): string {
    let _key = "",
      counter = 0;
    // reverse the string and insert 9 to 0 numbers after every char
    for (let i = key.length - 1; i >= 0; i--) {
      if (counter > 9) {
        counter = 0;
      }
      _key += key[i] + counter.toString();
      counter++;
    }
    return _key;
  }


  async hashString(pin: string) {
    const salt = await genSalt(10);
   const hashedPIN  = await hash(pin, salt);
   return hashedPIN;
  }
  async compareHashString(rowString : string, hashedString : string) {
    const result  = await compare(rowString, hashedString)
    return result;
  }


  async getApplicationBuildVersion(): Promise<AppVersionResponse> {
    const baseUrl = `${Environment.baseUrl}/public/auth/build/info`;
    const response = await this.httpSvc.get<AjaxResponse<AppVersionResponse>>([baseUrl], true);
    return response.data;
  }


}
